export const NO_TIME = '00:00';
export const DAY_HOURS_NUMBER = 24;
export const THIRTY_MINUTES = 30;
export const HOUR_IN_MINUTES = 60;
